// import React, { useState, useEffect, useContext, useRef } from 'react';
// import {
// 	Container,
// 	Stack,
// 	AppBar,
// 	Toolbar,
// 	Typography,
// 	Dialog,
// 	IconButton,
// 	TableContainer,
// 	Table,
// 	TableCell,
// 	TableRow,
// 	TableHead,
// 	TableBody
// } from '@mui/material';
// import { isEmpty } from 'lodash';

// import { useParams } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';

// import { DataContext } from '../../../context/DataContext';

// import { getRol, getToken, getUser } from '../../../api/Account';
// import ReactToPrint from 'react-to-print';
// import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
// import NoData from '../../../components/NoData';
// import moment from 'moment';
// import { getSucursalByUserAsync } from '../../../api/Users';
// import { simpleMessage } from '../../../helpers/Helpers';
// import { getBalanceGralAsync } from '../../../api/AdmonReport';
// import { PrintReportGerencial } from '../../../components/PrintReportGerencial';

// const ReporteBalanceGeneral = () => {
// 	const [data, setData] = useState([]);
// 	const [sucursalName, setSucursalName] = useState('');

// 	const compRef = useRef();
// 	const { selectedSucursal, selectedYear, selectedMonth, presentacion, cuentas0 } = useParams();

// 	const { setIsLoading, setIsUnautorized, title, slogan, icon } = useContext(DataContext);

// 	const token = getToken();
// 	const user = getUser();
// 	const rol = getRol();

// 	useEffect(() => {
// 		(async () => {
// 			let sucursals = await getSucursals();

// 			if (selectedSucursal === 't') {
// 				setSucursalName('Todas');
// 			} else {
// 				let name = sucursals.filter((item) => item.id.toString() === selectedSucursal);
// 				setSucursalName(name[0].description);
// 			}

// 			const data = {
// 				year: selectedYear,
// 				month: selectedMonth,
// 				sucursalId: selectedSucursal === 't' ? 0 : selectedSucursal,
// 				isResumido: presentacion === '2',
// 				incluideCuentas0: cuentas0 === '1'
// 			};

// 			setIsLoading(true);
// 			const result = await getBalanceGralAsync(token, data);
// 			if (!result.statusResponse) {
// 				setIsLoading(false);
// 				if (result.error === 'Unauthorized') {
// 					setIsUnautorized(true);
// 					return;
// 				}
// 				simpleMessage(result.error, 'error');
// 				return;
// 			}
// 			setIsLoading(false);
// 			setData(result.data.result);
// 		})();
// 	}, []);

// 	const getSucursals = async () => {
// 		setIsLoading(true);
// 		const result = await getSucursalByUserAsync(token);
// 		if (!result.statusResponse) {
// 			setIsLoading(false);
// 			if (result.error === 'Unauthorized') {
// 				setIsUnautorized(true);
// 				return;
// 			}
// 			simpleMessage(result.error, 'error');
// 			return;
// 		}
// 		setIsLoading(false);
// 		return result.data.result;
// 	};

// 	const getPC = () => {
// 		let totalPasivos = 0;
// 		let totalCapital = 0;
// 		data.map((item) => {
// 			if (item.cuenta.countNumber === '2') {
// 				totalPasivos = item.total;
// 			}
// 			if (item.cuenta.countNumber === '3') {
// 				totalCapital = item.total;
// 			}
// 		});
// 		return totalPasivos + totalCapital;
// 	};

import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import {
	Container,
	Stack,
	AppBar,
	Toolbar,
	Typography,
	Dialog,
	IconButton,
	TableContainer,
	Table,
	TableCell,
	TableRow,
	TableHead,
	TableBody
} from '@mui/material';
import { isEmpty } from 'lodash';

import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';

import { DataContext } from '../../../context/DataContext';
import { getRol, getToken, getUser } from '../../../api/Account';
import ReactToPrint from 'react-to-print';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import NoData from '../../../components/NoData';
import moment from 'moment';

import * as XLSX from 'xlsx/xlsx.mjs';

import { getSucursalByUserAsync } from '../../../api/Users';
import { simpleMessage } from '../../../helpers/Helpers';
import { getBalanceGralAsync } from '../../../api/AdmonReport';
import { PrintReportGerencial } from '../../../components/PrintReportGerencial';

const ReporteBalanceGeneral = () => {
	const [data, setData] = useState([]);
	const [sucursalName, setSucursalName] = useState('');

	const compRef = useRef();
	const { selectedSucursal, selectedYear, selectedMonth, presentacion, cuentas0 } = useParams();
	const { setIsLoading, setIsUnautorized, title, slogan, icon } = useContext(DataContext);

	const token = getToken();
	const user = getUser();
	const rol = getRol();

	const fechaDesde = useMemo(
		() => new Date(selectedYear, selectedMonth - 1, 1),
		[selectedYear, selectedMonth]
	);
	const fechaHasta = useMemo(
		() => new Date(fechaDesde.getFullYear(), fechaDesde.getMonth() + 1, 0),
		[fechaDesde]
	);

	useEffect(() => {
		const loadData = async () => {
			try {
				setIsLoading(true);
				const sucursals = await getSucursalByUserAsync(token);

				if (!sucursals.statusResponse) {
					return handleError(sucursals.error);
				}

				const s = sucursals.data.result;
				const name =
					selectedSucursal === 't'
						? 'Todas'
						: s.find((x) => x.id.toString() === selectedSucursal)?.description || '';
				setSucursalName(name);

				const payload = {
					year: selectedYear,
					month: selectedMonth,
					sucursalId: selectedSucursal === 't' ? 0 : selectedSucursal,
					isResumido: presentacion === '2',
					incluideCuentas0: cuentas0 === '1'
				};

				const result = await getBalanceGralAsync(token, payload);
				if (!result.statusResponse) {
					return handleError(result.error);
				}

				setData(result.data.result);
			} finally {
				setIsLoading(false);
			}
		};

		loadData();
	}, []);

	const handleError = (error) => {
		setIsLoading(false);
		if (error === 'Unauthorized') {
			setIsUnautorized(true);
			return;
		}
		simpleMessage(error, 'error');
	};

	/** CALCULO PASIVO + CAPITAL */
	const totalPasivoCapital = useMemo(() => {
		let p = 0;
		let c = 0;
		data.forEach((i) => {
			if (i.cuenta.countNumber === '2') p = i.total;
			if (i.cuenta.countNumber === '3') c = i.total;
		});
		return p + c;
	}, [data]);

	const getPC = () => {
		let totalPasivos = 0;
		let totalCapital = 0;
		data.map((item) => {
			if (item.cuenta.countNumber === '2') {
				totalPasivos = item.total;
			}
			if (item.cuenta.countNumber === '3') {
				totalCapital = item.total;
			}
		});
		return totalPasivos + totalCapital;
	};

	const exportExcel = () => {
		if (!data || data.length === 0) {
			simpleMessage('No hay datos para exportar.', 'warning');
			return;
		}

		const exp = data.map((item) => {
			const { cuenta, subtotal, total } = item;

			return {
				NumeroCuenta: cuenta.countNumber,
				Descripcion: cuenta.descripcion,
				Nivel: cuenta.nivel,
				SubTotal: subtotal,
				Total: total
			};
		});

		// ➕ Agregamos la última fila PASIVO + CAPITAL
		exp.push({
			NumeroCuenta: '',
			Descripcion: 'PASIVO + CAPITAL',
			Nivel: '',
			SubTotal: '',
			Total: getPC()
		});
		// Crear libro y hoja
		const workbook = XLSX.utils.book_new();
		const worksheet = XLSX.utils.json_to_sheet(exp);

		// Agregar hoja al libro
		XLSX.utils.book_append_sheet(workbook, worksheet, 'BalanceGeneral');

		// Descargar archivo
		XLSX.writeFile(workbook, `BalanceGeneral_${moment().format('DDMMYYYY_HHmm')}.xlsx`);
	};

	/** RENDER TABLA DE DATOS (para UI y Print) */
	const renderTable = () => (
		<TableContainer>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell>No de Cuenta</TableCell>
						<TableCell>Descripción de Cuenta</TableCell>
						<TableCell align="center">Sub - Total</TableCell>
						<TableCell align="center">Total</TableCell>
					</TableRow>
				</TableHead>

				<TableBody>
					{data.map(({ cuenta, subtotal, total }) => (
						<TableRow key={cuenta.id}>
							<TableCell>{cuenta.countNumber}</TableCell>

							<TableCell>
								<Typography style={{ fontSize: 12, marginLeft: cuenta.nivel * 10 }}>
									{cuenta.descripcion}
								</Typography>
							</TableCell>

							<TableCell align="center">
								{subtotal.toLocaleString('es-NI', {
									style: 'currency',
									currency: 'NIO'
								})}
							</TableCell>

							<TableCell align="center">
								{total.toLocaleString('es-NI', {
									style: 'currency',
									currency: 'NIO'
								})}
							</TableCell>
						</TableRow>
					))}

					<TableRow>
						<TableCell colSpan={3} align="left" style={{ fontWeight: 'bold' }}>
							PASIVO + CAPITAL
						</TableCell>
						<TableCell align="center" style={{ fontWeight: 'bold' }}>
							{totalPasivoCapital.toLocaleString('es-NI', {
								style: 'currency',
								currency: 'NIO'
							})}
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</TableContainer>
	);

	return (
		<div>
			<Dialog fullScreen open={true}>
				{/* ---- HEADER ---- */}
				<AppBar sx={{ position: 'relative' }}>
					<Toolbar>
						<img src={icon} alt="logo" style={{ height: 40 }} />
						<Typography sx={{ ml: 2, flex: 1, textAlign: 'center' }} variant="h5">
							{title}
						</Typography>
						<img src={icon} alt="logo" style={{ height: 40 }} />
					</Toolbar>
				</AppBar>

				{/* ---- CONTROLES ---- */}
				<Stack justifyContent="center">
					<Stack direction="row" justifyContent="space-between" px={5} my={1}>
						<IconButton onClick={() => exportExcel()}>
							<FontAwesomeIcon
								icon={faCloudArrowDown}
								style={{ fontSize: 40, color: '#00a152', width: 40, height: 40 }}
							/>
						</IconButton>

						<Stack textAlign="center">
							<Typography sx={{ color: '#2196f3', fontWeight: 'bold' }}>
								{slogan}
							</Typography>
							<Typography sx={{ color: '#2196f3', fontWeight: 'bold' }} variant="h6">
								Balance General
							</Typography>
						</Stack>

						<ReactToPrint
							trigger={() => (
								<IconButton>
									<PrintRoundedIcon
										style={{
											fontSize: 35,
											color: '#2979ff',
											width: 40,
											height: 40
										}}
									/>
								</IconButton>
							)}
							content={() => compRef.current}
						/>
					</Stack>

					{/* ---- PARÁMETROS ---- */}
					<Container maxWidth={false}>
						<Stack direction="row" justifyContent="space-between">
							<Stack>
								<Typography fontSize={11}>Sucursal: {sucursalName}</Typography>
								<Typography fontSize={11}>
									Desde: {moment(fechaDesde).format('L')} — Hasta:{' '}
									{moment(fechaHasta).format('L')}
								</Typography>
							</Stack>

							<Stack>
								<Typography fontSize={11}>Usuario: {user}</Typography>
								<Typography fontSize={11}>
									Fecha: {moment().format('DD/MM/YYYY hh:mm A')}
								</Typography>
							</Stack>
						</Stack>
					</Container>
				</Stack>

				{/* ---- TABLA ---- */}
				<Container maxWidth={false}>
					<hr />
					{isEmpty(data) ? <NoData /> : renderTable()}
				</Container>
			</Dialog>

			{/* ---------- COMPONENTE PARA IMPRESIÓN ---------- */}
			<div style={{ display: 'none', background: '#fff', color: '#000' }}>
				<PrintReportGerencial
					ref={compRef}
					titulo="Balance General"
					fecha={`Fecha: ${moment().format('L')}`}
					rango={`Del ${moment(fechaDesde).format('L')} al ${moment(fechaHasta).format(
						'L'
					)}`}
					isLandscape={false}
				>
					<Container maxWidth="lg">
						{isEmpty(data) ? <NoData /> : renderTable()}
					</Container>
				</PrintReportGerencial>
			</div>
		</div>
	);
};

export default ReporteBalanceGeneral;
